export default "__VITE_ASSET__DzvPmoAI__"